import { c as _c } from "react/compiler-runtime";
import { COURSE_BUNDLES_API } from 'modules/courses/bundles/api/course-bundles-api';
import { CourseInterface } from 'modules/courses/bundles/course-bundle/types/course-bundle-interface';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import useUser from 'shared/hooks/use-user';
import { baseFetcher } from 'shared/utils/http-client';
import { coursesDependencies } from '../../../constants/courses-dependencies';
export function useCoursesList(id) {
  const $ = _c(6);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] !== id || $[1] !== user) {
    t0 = () => {
      if (user) {
        return [`${COURSE_BUNDLES_API}/${id}/list-all`, ...coursesDependencies];
      }
      return null;
    };
    $[0] = id;
    $[1] = user;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const {
    data: courseList,
    mutate
  } = useControlledSwr(t0, baseFetcher);
  let t1;
  if ($[3] !== courseList || $[4] !== mutate) {
    t1 = {
      courseList,
      mutate
    };
    $[3] = courseList;
    $[4] = mutate;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}